import { Component, inject, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import {
  MatListItem,
  MatListOption,
  MatSelectionList,
} from '@angular/material/list';
import { MatSpinner } from '@angular/material/progress-spinner';
import {
  CalendarService,
  GoogleCalendar,
  UserTokenCalendars,
} from '@sia/calendar';
import { notify, SiaTooltipDirective, SiaTranslatePipe } from '@sia/shared';
import { SiaGoogleAuthButtonComponent } from '../../components/sia-google-auth-button/sia-google-auth-button.component';
import { SiaGoogleLogoutButtonComponent } from '../../components/sia-google-logout-button/sia-google-logout-button.component';

@Component({
  selector: 'sia-google-auth-dialog',
  imports: [
    MatIcon,
    MatButton,
    SiaGoogleLogoutButtonComponent,
    SiaTooltipDirective,
    SiaTranslatePipe,
    SiaGoogleAuthButtonComponent,
    MatSelectionList,
    MatListOption,
    MatSpinner,
    MatListItem,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  standalone: true,
  templateUrl: './sia-google-auth-dialog.component.html',
  styleUrls: ['./sia-google-auth-dialog.component.scss'],
})
export class SiaGoogleAuthDialogComponent {
  private calendarService = inject(CalendarService);
  private dialog = inject(MatDialog);
  refresh = output<string>();
  client_id?: string;
  scope: string = `email https://www.googleapis.com/auth/calendar openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar.calendarlist https://www.googleapis.com/auth/calendar.calendars https://www.googleapis.com/auth/calendar.events`;

  scopeType: string = 'Calendar';
  scopeName: string = 'calendar';
  text?: string;
  hasCalendars: boolean = false;
  spinner: boolean = false;
  logged: boolean = false;
  calendars: GoogleCalendar[] = [];
  selectedOptions: string[] = [];
  timeOutGoogleCalendar: any;

  syncGoogleCalendars() {
    if (!this.hasCalendars && this.logged) {
      notify('Nessun calendario google trovato', 1500, 'warning');
    }
    this.spinner = true;
    this.selectedOptions = this.calendars
      .filter((a) => a.sync ?? false)
      .map((a) => {
        return a.id ?? '';
      });
    this.calendarService
      .syncGoogleCalendars(this.selectedOptions)
      .then((res: any) => {
        // this.refresh.emit('');
        this.spinner = false;
        notify('Sincronizzazione avvenuta con successo', 1500, 'success');
      });
    this.closeDialog();
  }

  getGoogleCalendars() {
    this.calendarService
      .getGoogleCalendars()
      .then((res: UserTokenCalendars) => {
        this.logged = res.isValidToken ?? false;
        this.calendars = res.syncCalendars ?? [];
        this.spinner = false;
        this.hasCalendars = this.calendars.length > 0;
      });
  }

  async logout() {
    this.spinner = true;
    this.spinner = false;
    this.logged = false;
    this.calendars = [];
    this.selectedOptions = [];
    this.refresh.emit('');
    await this.calendarService.logoutGoogleCalendar();
    notify('I tuoi calendari sono stati cancellati', 1500, 'success');
  }

  login($event: any) {
    clearTimeout(this.timeOutGoogleCalendar);
    this.logged = true;
    this.spinner = true;
    this.calendarService
      .firstSyncGoogle()
      .then((val: any) => {
        this.getGoogleCalendars();
      })
      .catch((err: any) => {});
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  ngOnInit() {
    this.getGoogleCalendars();
    this.calendarService.getGoogleCalendarClientId().then((clientId: any) => {
      if (clientId) {
        this.client_id = clientId;
      } else {
        notify('Impossibile configurare i calendari Google', 3000, 'error');
      }
    });
  }
  ngOnDestroy() {
    if (this.timeOutGoogleCalendar) {
      clearTimeout(this.timeOutGoogleCalendar);
    }
  }
}
